import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
export function CookieConsentFn() {
    $(document).ready(() => {
        let locale = $("body").attr("data-locale");
        $.getJSON("/cookie-consent-data?locale=" + locale, (data) => {
            const CookieConsentNode = new CookieConsent(data);
            CookieConsentNode.init();
        });
    });
}
